export default interface solicitationId {
  id: number;
}

const solicitationIdInitialValue: solicitationId = {
  id: 0
};

export { solicitationIdInitialValue };
